var _defs, _path, _path2, _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoundpocket01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 423 520",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-104{fill:none;}.cls-104,.cls-103,.cls-102{stroke:#010101;stroke-miterlimit:10;}.cls-104,.cls-102{stroke-width:3px;}.cls-103,.cls-102{fill:#fff;}.cls-103{stroke-dasharray:3;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M346,174.38V372.66a43.73,43.73,0,0,1-43.72,43.72H120.72A43.73,43.73,0,0,1,77,372.66V174.38Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M120.72,413.38A40.77,40.77,0,0,1,80,372.66V177.38H343V372.66a40.77,40.77,0,0,1-40.72,40.72Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 77,
    y: 122.38,
    width: 269,
    height: 52
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-103",
    x: 80,
    y: 125.38,
    width: 263,
    height: 46
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundpocket01);
export default __webpack_public_path__ + "static/media/ROUND POCKET-01.0db141a65003f0d921b58ec8d8cc0147.svg";
export { ForwardRef as ReactComponent };